<template>
  <div>
    <b-row v-if="blocs.length > 0">
      <b-col xs="12" sm="6" md="3" v-for="(bloc, index) in blocs" :key="index">
        <RecapBlockContainer
          :recap_property="bloc"
          :index="index"
          :key="index"
          @shiftUpBlock="shiftUpBlock"
          @shiftDownBlock="shiftDownBlock"
          @deleteBlock="deleteBlock"
        ></RecapBlockContainer>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <b-alert show variant="warning"
          >Aucun bloc récapitulatif pour ce parcours, ajouter des élements via
          la bouton ci-dessous</b-alert
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="align_center" style="margin-top: 20px">
        <b-button class="button_save_admin" @click="addRecapBloc"
          >Ajouter un bloc</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { RecapBlock } from "@/classes/Blocks/RecapBlock.js";
import RecapBlockContainer from "@/components/Admin_tab/Blocks/RecapBlockContainer.vue";
export default {
  props: ["blocs_recap"],
  components: { RecapBlock, RecapBlockContainer },
  data() {
    return {
      blocs: [],
    };
  },
  methods: {
    addRecapBloc() {
      this.blocs.push(new RecapBlock("recap"));
    },
    shiftUpBlock(index) {
      var block = this.blocs[index];
      this.blocs.splice(index, 1);
      this.blocs.splice(index - 1, 0, block);
      this.$forceUpdate();
    },
    shiftDownBlock(index) {
      var block = this.blocs[index];
      this.blocs.splice(index, 1);
      this.blocs.splice(index + 1, 0, block);
      this.$forceUpdate();
    },
    deleteBlock(index) {
      this.blocs.splice(index, 1);
      this.$forceUpdate();
    },
  },
  created() {
    this.blocs = this.blocs_recap;
  },
};
</script>

<style lang="scss" scoped>
</style>